import React from 'react'
import Modal from 'presentation/hospital/components/Modal'
import * as S from './styles'
import { ReactComponent as CloseIcon } from 'presentation/assets/icons/close-icon.svg'
import SelectFieldNew from 'presentation/shared/components/SelectFieldNew'
import TextAreaNew from 'presentation/shared/components/TextAreaNew'
import Button from 'presentation/shared/components/Button'
import { useFormik } from 'formik'
import { ValidationSchema } from './validationSchema'
import { ReasonsCancellationModel } from 'domain/entities/reasons-cancellation'
import { useServices } from 'presentation/hooks/use-services'
import {
  WithLoading,
  WithLoadingProps
} from 'presentation/shared/components/HOCs/WithLoading'
import { SurgicalOrderModel } from 'domain/entities/surgical-order-model'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router'
import { ApiStatusCode } from 'service/protocols/api/api-client'

type SolicitationCancelOrderModalProps = {
  handleClose: () => void
  reasons?: ReasonsCancellationModel[]
  solicitationCancelOrder?: number
  surgicalOrder?: SurgicalOrderModel
} & WithLoadingProps

export const SolicitationCancelOrderModal = WithLoading(
  ({
    solicitationCancelOrder,
    reasons,
    surgicalOrder,
    setIsLoading,
    handleClose
  }: SolicitationCancelOrderModalProps) => {
    const surgicalOrderService = useServices().surgicalOrder
    const surgicalPendencyService = useServices().surgicalPendency
    const history = useHistory()

    const mapperReasons = reasons?.map((item: any) => {
      return {
        value: item.code,
        label: item.description
      }
    })

    const formik = useFormik({
      initialValues: {
        reason: '',
        observations: ''
      },
      validationSchema: ValidationSchema,
      validateOnChange: true,
      validateOnMount: true,
      onSubmit: async (values) => {
        if (!solicitationCancelOrder || !surgicalOrder?.surgical_order_id) {
          toast.error(
            'Não foi possível identificar a solicitação de cancelamento. Atualize a página e tente novamente.'
          )
          return
        }

        setIsLoading(true)
        try {
          const codeToInt = parseInt(values.reason)

          const response = await surgicalOrderService.cancelSurgicalOrder({
            code: codeToInt,
            observation: values.observations,
            surgical_cancellation_id: solicitationCancelOrder,
            mv_reason_cancellation_code: codeToInt,
            reason_description: formatedDate(reasons, codeToInt),
            mv_reason_description: formatedDate(reasons, codeToInt),
            surgical_order_id: surgicalOrder?.surgical_order_id
          })

          if (response.statusCode !== ApiStatusCode.ok) {
            throw new Error(
              (response as any)?.message || 'Erro ao cancelar pedido cirúrgico.'
            )
          }

          if (surgicalOrder?.pendencies) {
            await Promise.all(
              surgicalOrder.pendencies.map(async (surgicalPendency: any) => {
                await surgicalPendencyService.finishSurgicalPendency({
                  surgical_pendency_id: surgicalPendency.surgical_pendency_id
                })
              })
            )
          }

          await surgicalOrderService.finishActiveSearchers({
            surgical_order_id: surgicalOrder?.surgical_order_id
          })

          toast.success('O pedido cirúrgico foi cancelado.')
          history.push('/pedido-cancelado/resumo', {
            surgical_order_id: surgicalOrder?.surgical_order_id,
            patient_id: surgicalOrder?.patient?.patient_id
          })
        } catch (error) {
          toast.error(
            (error as any)?.message ||
              'Erro ao cancelar pedido cirúrgico. Por favor tente novamente.'
          )
        } finally {
          setIsLoading(false)
        }
      }
    })

    const formatedDate = (reasons?: any, codeToInt?: number) => {
      if (reasons && codeToInt) {
        const item = reasons.find((item: any) => item.code === codeToInt)
        const description = item?.description
        return description
      } else {
        return ''
      }
    }

    return (
      <Modal>
        <S.Container>
          <S.Wrapper>
            <S.Title>Cancelar pedido cirúrgico</S.Title>
            <S.CancelButton onClick={() => handleClose()}>
              <CloseIcon />
            </S.CancelButton>
          </S.Wrapper>

          <S.Separator />

          <SelectFieldNew
            items={mapperReasons}
            value={formik.values.reason}
            onBlur={formik.handleBlur('reason')}
            onChange={formik.handleChange('reason')}
            style={{ marginBottom: '1em' }}
            label="Informe o motivo de cancelar o aviso cirúrgico"
            required
          />

          <TextAreaNew
            value={formik.values.observations}
            onBlur={formik.handleBlur('observations')}
            onChange={formik.handleChange('observations')}
            style={{ marginBottom: '1em', height: '100px' }}
            label="Observações"
            placeholder="Caso queira complementar alguma informação, digite aqui"
            error={formik.errors.observations}
          />

          <S.ButtonContainer>
            <Button
              onClick={formik.submitForm}
              type="button"
              style={{
                width: 245,
                fontSize: '16px'
              }}
              disabled={!formik.values.reason || !!formik.errors?.observations}
            >
              Confirmar cancelamento
            </Button>
          </S.ButtonContainer>
        </S.Container>
      </Modal>
    )
  }
)
